import { logger } from "@/infrastructure/services/LoggerService";
export function parseByoHost(value) {
    if (!value || typeof value !== "object") {
        return null;
    }
    const { clientId, organization } = value;
    if (typeof clientId !== "string" || clientId === "") {
        return null;
    }
    if (typeof organization !== "string" || organization === "") {
        return null;
    }
    return { clientId, organization };
}
/**
 * Returns this hostname's entry, served by nginx at `/byo-host.json`, or `null` on a canonical
 * hostname (204, no body), in a dev build, and on any failure.
 */
export async function loadByoHost() {
    if (!import.meta.env.PROD) {
        return null;
    }
    try {
        const response = await fetch("/byo-host.json", { cache: "no-store" });
        // 204 means a canonical hostname; anything but 200 has no entry to parse.
        if (response.status !== 200) {
            return null;
        }
        return parseByoHost(await response.json());
    }
    catch (error) {
        logger.error("Failed to load /byo-host.json:", error);
        return null;
    }
}
